<template>
    <div>
        <div class="users box-white-wrapper">
            <vs-table search :data="types" pagination max-items="20">
                <template slot="header">
                    <vs-button color="primary" @click="openModal()" type="border" icon="library_add">Agregar Tipo Cliente</vs-button>
                </template>
                <template slot="thead">
                    <vs-th sort-key="code">Código </vs-th>
                    <vs-th sort-key="name">Nombre </vs-th>
                    <vs-th sort-key="description">Descripción</vs-th>
                    <vs-th sort-key="rate">Costo</vs-th>
                    <vs-th sort-key=""></vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                        <vs-td :data="data[indextr].code">
                            {{data[indextr].code}}
                        </vs-td>
                        <vs-td :data="data[indextr].name">
                            {{data[indextr].name}}
                        </vs-td>
                        <vs-td :data="data[indextr].description">
                            {{data[indextr].description}}
                        </vs-td>
                        <vs-td :data="data[indextr].rate">
                            {{data[indextr].rate}} USD
                        </vs-td>
                        <vs-td :data="data[indextr].code">
                            <div class="table-actions">
                                <a href="javascript:void(0)" @click="editCustomerType(data[indextr].code)"><feather type="edit-2"/></a>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            <transition name="fade">
                <ModalBasic :show="ModalActive">
                    <div class="modal-header" slot="modal-header">{{ ModalTitle }}</div>
                    <div class="modal-body" slot="modal-body">
                        <form>
                            <div :class="['form-input',{'has-error': $v.customerType.code.$error }]" v-if="!isUpdating">
                                <vs-input label="Código" v-model.trim="$v.customerType.code.$model"/>
                                <span class="error-text" v-if="$v.customerType.code.$error"><feather type="info" />Este campo es requerido</span>
                            </div>
                            <div :class="['form-input',{'has-error': $v.customerType.name.$error }]">
                                <vs-input label="Nombre" v-model.trim="$v.customerType.name.$model"/>
                                <span class="error-text" v-if="$v.customerType.name.$error"><feather type="info" />Este campo es requerido</span>
                            </div>
                            <div :class="['form-input',{'has-error': $v.customerType.rate.$error }]">
                                <vs-input label="Costo" v-model.trim="$v.customerType.rate.$model" @keypress="isNumber($event)"/>
                                <span class="error-text" v-if="$v.customerType.rate.$error"><feather type="info" />Este campo es requerido</span>
                            </div>
                            <div class="form-input">
                                <vs-input label="Descripción" v-model.trim="customerType.description"/>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer" slot="modal-footer">
                        <vs-button color="danger" type="border" icon="block"  @click="closeModal()">Cancelar</vs-button>
                        <vs-button :disabled="confirmStatus || $v.$invalid" id="btnConfirm" color="success" type="border" icon="check" 
                            @click="handleRequest" class="vs-con-loading__container"> {{ !isUpdating ? 'Guardar' : 'Actualizar' }}</vs-button>
                    </div>
                </ModalBasic>
            </transition>
        </div>
    </div>
</template>
<script>
import CustomerType from '@/models/CustomerType';
import CustomerTypeService from "@/services/CustomerTypeService";
import ModalBasic from '@/components/Modal/Basic.vue'
import { required } from 'vuelidate/lib/validators'
import {helper} from '@/helpers/utils'
export default {
    name: 'taxes',
    mixins: [helper],
    components: {
      ModalBasic,
    },
    data() {
      return {
        types: [],
        ModalActive: false,
        confirmStatus: false,
        isUpdating: false,        
        customerType: new CustomerType(),
        ModalTitle: 'Nuevo Tipo Cliente',
      }
    },
    validations: {
        customerType:
          {
            code:{ required },
            name:{ required },
            rate:{ required },
          },
    },
    beforeMount() {
        this.$Progress.start();
    },
    mounted () {
      this.retrieveCustomerTypes()
    },
    methods:{
        openModal () {
          this.customerType = new CustomerType()
          this.ModalActive = true
          this.isUpdating  = false
          this.$v.$reset()
        },
        closeModal () {
            this.ModalTitle  = 'Nuevo Tipo Cliente'
            this.ModalActive = false
            this.customerType = new CustomerType()
            this.$v.$reset()
        },
        editCustomerType (id) {
          console.log(id)
          this.ModalTitle   = "Editar Tipo Cliente"
          this.customerType = this.searchCustomerType(id);
          this.ModalActive  = true
          this.isUpdating   = true
        },
        handleRequest(){
            this.$v.$touch()
            if (this.$v.$invalid) return;
            if (!this.isUpdating) {
                this.createCustomerType()
            } else {
                this.updateCustomerType()
            }
        },
        createCustomerType(){
            const that = this
            console.log(this.tax);
            that.loadingProgress ('#btnConfirm')
            that.confirmStatus = true
            CustomerTypeService.newCustomerType(that.customerType)
            .then(response => {
                that.confirmStatus = false
                console.log(response)
                that.$vs.loading.close('#btnConfirm .con-vs-loading')
                that.ModalActive = false
                that.$vs.notify({title:'Creado!',text:'El tipo de cliente fue creado exitosamente!',color:'success',icon:'check'})
                that.customerType = new CustomerType()
                this.$v.$reset()
                this.retrieveCustomerTypes()
            })
            .catch(e => {
                console.log(e)
                that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
                that.confirmStatus = false
                that.$vs.notify({title:'Información!',text:'Error creando el tipo de cliente',color:'danger',icon:'error_outline'})                
            });
        },
        updateCustomerType(){
            const that = this
            that.loadingProgress ('#btnConfirm')
            that.confirmStatus = true
            CustomerTypeService.updateCustomerType(that.customerType)
            .then(response => {
                that.confirmStatus = false
                console.log(response)
                that.$vs.loading.close('#btnConfirm .con-vs-loading')
                that.ModalActive = false
                that.$vs.notify({title:'Información!',text:'El tipo de cliente fue modificado exitosamente!',color:'success',icon:'check'})
                that.customerType = new CustomerType()
                this.retrieveCustomerTypes()
                this.$v.$reset()
            })
            .catch(e => {
                console.log(e)
                that.ModalActive = false
                that.confirmStatus = false
                that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
                that.$vs.notify({title:'Información!',text:'Error actualizando el tipo de cliente',color:'danger',icon:'error_outline'})
            });
        },
        searchCustomerType (_code) {
            let objCustomerType = this.types.filter((item) => {
              return _code === item.code
            })
            objCustomerType =  objCustomerType[0]
            let newType = new CustomerType(objCustomerType.code, objCustomerType.name, objCustomerType.description, objCustomerType.rate);
            return newType
        },
        
        retrieveCustomerTypes() {
            CustomerTypeService.getCustomerTypes()
            .then(response => {
                console.log(response.data)
                this.types = response.data;
                this.$Progress.finish()
            })
            .catch(e => {
                console.log(e);
                this.$Progress.finish()
                this.$vs.notify({title:'Error!',text:'Error obteniendo los tipos de clientes!',color:'danger',icon:'error_outline'})
            });
        },
    }
}
</script>
